import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Button from '../../../components/common/Button';
import formatCardNumber from '../../../utils/formatCardNumber';
import FormMessage from '../../FormMessage';
import { activateNewCard, resendAttempt } from '../actions';
import { getCardNumber, getPhoneNumber } from '../selectors';
import contentStackImageUrls from '../../../../resources/contentStackImageUrls.json';

const { tick } = contentStackImageUrls;

export const Success = ({ cardNumber, phoneNumber, activateAnother, resend }) => (
  <div className="registration-success container--fixed-wide">
    <div className="container--fixed">
      <FormMessage className="registration-success__form-message" />
    </div>
    <img
      src={tick}
      onError={(e) => { e.target.src = '../../../../assets/images/tick.png'; }}
      className="registration-success__icon"
    />
    <h1 className="registration-success__header">Success!</h1>
    <p className="registration-success__text">
      Your PLUS card has been successfully linked PLUS
      card <b>{formatCardNumber(cardNumber)}</b> with<br />mobile number <b>{phoneNumber}</b>.
    </p>
    <p className="registration-success__text">
      You will receive a confirmation message shortly that will confirm
      the activation of<br />your PLUS card. This may take up to 5 minutes to arrive.
    </p>
    <div className="registration-success__buttons-line container--fixed">
      <Button
        className="registration-success__button"
        onClick={activateAnother}
      >
        Activate another
      </Button>
    </div>
    <p className="registration-success__text">
      <span className="registration-success__link" onClick={resend}>
        Not received a confirmation message?
      </span>
    </p>
  </div>
);

Success.propTypes = {
  cardNumber: PropTypes.string.isRequired,
  activateAnother: PropTypes.func.isRequired,
  resend: PropTypes.func.isRequired,
  phoneNumber: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  cardNumber: getCardNumber(state),
  phoneNumber: getPhoneNumber(state)
});

const mapDispatchToProps = {
  activateAnother: activateNewCard,
  resend: resendAttempt
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Success));
